import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { LuMessageSquarePlus, LuCreditCard, LuWallet, LuLink } from 'react-icons/lu';
import { Col, Container, Row } from 'react-bootstrap';

import { isFeatureEnabled } from 'helpers';
import { Tabs } from '_components/_core';

import {
  Notifications,
  PaymentGateways,
  PaymentMethods,
  PaymentMethodGateway,
  ChargeStatus,
  ChargeStatusPaymentGateway,
} from './components';

function Admin({ user }) {
  const [activeTab, setActiveTab] = useState('notifications');

  const getTabs = useCallback(() => {
    const tabs = [
      {
        id: 'notifications',
        title: 'Notificações',
        icon: <LuMessageSquarePlus className="mr-2" />,
        content: activeTab === 'notifications' && <Notifications />,
      },
      {
        id: 'payment-gateways',
        title: 'Gateways de Pagamento',
        icon: <LuCreditCard className="mr-2" />,
        content: activeTab === 'payment-gateways' && <PaymentGateways />,
      },
      {
        id: 'payment-methods',
        title: 'Métodos de Pagamento',
        icon: <LuWallet className="mr-2" />,
        content: activeTab === 'payment-methods' && <PaymentMethods />,
      },
      {
        id: 'payment-method-gateway',
        title: 'Assoc. de Métodos de Pagamento',
        icon: <LuLink className="mr-2" />,
        content: activeTab === 'payment-method-gateway' && <PaymentMethodGateway />,
      },
      {
        id: 'charge-status',
        title: 'Status de Pagamento',
        icon: <LuWallet className="mr-2" />,
        content: activeTab === 'charge-status' && <ChargeStatus />,
      },
      {
        id: 'charge-status-payment-gateway',
        title: 'Assoc. de Status de Pagamento',
        icon: <LuLink className="mr-2" />,
        content: activeTab === 'charge-status-payment-gateway' && (
          <ChargeStatusPaymentGateway />
        ),
      },
    ];

    return tabs;
  }, [activeTab]);

  if (!isFeatureEnabled('superadmin', user.flags)) {
    return null;
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <h4 className="mt-2 mb-3">Administrador</h4>
          <Tabs
            variant="secondary"
            tabs={getTabs()}
            activeTab={activeTab}
            onTabChange={tab => setActiveTab(tab)}
          />
        </Col>
      </Row>
    </Container>
  );
}

Admin.propTypes = {
  onCreateSingleNotification: PropTypes.func.isRequired,
};

export default Admin;
